import React from 'react';
import { Outlet } from 'react-router-dom';
import { observer } from 'mobx-react';
import { ROUTES } from './constants/routes';

const RewardsPage = observer(() => <Outlet />);

RewardsPage.ROUTES = ROUTES;
export default RewardsPage;
